module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base badge-delegacion",
    class: {
      'is-in-mobile': _vm.isMobile
    },
    on: {
      "click": function($event) {
        _vm.showPopup = !_vm.showPopup
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarInactivarDelegación) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Inactivar delegación")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = false
      }
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("¿Estás seguro de inactivar la delegación?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.inactivar
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Inactivando...")]) : _c('span', [_vm._v("Inactivar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = false
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])]) : _vm._e()]), _c('strong', [_vm._v(_vm._s(_vm.estoySiendoReemplazado ? 'Estás siendo reemplazado por' : _vm.estoyReemplazando ? 'Estás reemplazando a' : '') + " " + _vm._s(_vm.isMobile ? _vm.nombreReemplazo : _vm.nombreReemplazoTrim))]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPopup) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "popup",
    class: {
      'popup-top': !_vm.isMobile, 'popup-bottom': _vm.isMobile
    },
    style: ({
      bottom: _vm.isMobile ? _vm.badgeHeight + 'px' : 'none'
    })
  }, [_c('h3', [_vm._v(_vm._s(_vm.estoySiendoReemplazado ? 'Siendo reemplazado por' : _vm.estoyReemplazando ? 'Reemplazando a' : '') + " "), _c('strong', [_vm._v(_vm._s(_vm.nombreReemplazo))])]), _c('p', [_vm._v("Fecha: " + _vm._s(_vm.fechaInicioFormat == _vm.fechaFinFormat ? _vm.fechaInicioFormat : _vm.fechaInicioFormat + ' - ' + _vm.fechaFinFormat))]), (_vm.estoySiendoReemplazado) ? _c('button', {
    staticClass: "button is-small is-danger mt-5",
    on: {
      "click": function($event) {
        _vm.mostrarInactivarDelegación = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Inactivar")])]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2ba2b6e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_delegaciones_mostrar_reemplazo.vue
// module id = 953
// module chunks = 0